<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import facebook from './images/facebook.svg';
	import instagram from './images/instagram.svg';
	import linkedin from './images/linkedin.svg';
	import pinterest from './images/pinterest.svg';
	import youtube from './images/youtube.svg';
</script>

<ul class="flex w-full list-none flex-row flex-wrap justify-around">
	<li>
		<a
			href="https://www.facebook.com/indowwindows"
			target="_blank"
			rel="noreferrer"
		>
			<Image src={facebook} alt="Facebook" class="aspect-square max-w-16" />
		</a>
	</li>

	<li>
		<a
			href="https://www.pinterest.com/indowwindows"
			target="_blank"
			rel="noreferrer"
		>
			<Image src={pinterest} alt="Pinterest" class="aspect-square max-w-16" />
		</a>
	</li>

	<li>
		<a
			href="https://www.instagram.com/indowwindows"
			target="_blank"
			rel="noreferrer"
		>
			<Image src={instagram} alt="Instagram" class="aspect-square max-w-16" />
		</a>
	</li>

	<li>
		<a
			href="https://www.youtube.com/user/IndowWindows"
			target="_blank"
			rel="noreferrer"
		>
			<Image src={youtube} alt="YouTube" class="aspect-square max-w-16" />
		</a>
	</li>

	<li>
		<a
			href="https://www.linkedin.com/company/indow"
			target="_blank"
			rel="noreferrer"
		>
			<Image src={linkedin} alt="LinkedIn" class="aspect-square max-w-16" />
		</a>
	</li>
</ul>
